import {getData, postUrlencodedData, api} from '../request';

export function getPagedServiceCaseList(index, size, callBack){
    getData(api.getServiceCaseList, {index: index, size: size})
        .then(res => {
            if (res.code === 200)
                callBack(res.data);
            else
                callBack(false, res.message);
        }, rej => {
            console.log(rej);
            callBack(false)
        });
}

export function updateServiceCase(data, callBack){
    postUrlencodedData(api.updateServiceCase(data.id), data)
        .then(res => {
            if (res.code === 200)
                callBack(true);
            else
                callBack(false, res.message);
        }, rej => {
            console.log(rej);
            callBack(false)
        });
}

export function deleteServiceCase(id, callBack) {
    postUrlencodedData(api.deleteServiceCase(id))
        .then(res => {
            if (res.code === 200)
                callBack(true);
            else
                callBack(false, res.message);
        }, rej => {
            console.log(rej);
            callBack(false)
        });
}

export function getServiceCaseDetail(id, callBack) {
    getData(api.getServiceCase(id))
        .then(res => {
            if (res.code === 200)
                callBack(res.data);
            else
                callBack(false, res.message);
        }, rej => {
            console.log(rej);
            callBack(false)
        });
}

export function addServiceCase(data, callBack) {
    postUrlencodedData(api.addServiceCase, data)
        .then(res => {
            if (res.code === 200)
                callBack(true);
            else
                callBack(false, res.message);
        }, rej => {
            console.log(rej);
            callBack(false)
        });
}
